<template>
  <header
    class="py-4 xl:py-0 xl:px-[14vw] bg-white z-20 w-full fixed border-b-2 border-primary"
    :class="{ fixed: openedNotification }"
  >
    <div class="px-5 py-2.5 flex items-center justify-between">
      <img @click="goTo('/dashboard')" src="/images/logo-invertido.png" alt="" class="h-10 xl:block" />
            <ul class="gap-x-6 hidden xl:flex">
                <a v-if="isMerchan" @click="putWaitResponse()" @click.middle="putWaitResponse()" :class="{'pointer-events-none' : waitResponse}" class="text-primary active:text-shade hover:underline font-bold" href="/dashboard">Home</a>
                <a v-if="isMerchan" @click="putWaitResponse()" @click.middle="putWaitResponse()" :class="{'pointer-events-none' : waitResponse}" class="text-primary active:text-shade hover:underline font-bold" href="/news">Feed</a>
                <a v-if="isMerchan" @click="putWaitResponse()" @click.middle="putWaitResponse()" :class="{'pointer-events-none' : waitResponse}" class="text-primary active:text-shade hover:underline font-bold" href="/campaigns">Materiais</a>
                <a v-if="isModerator && isComputer" class="text-primary active:text-shade hover:underline font-bold" href="/photo-voting" @click="putWaitResponse()" @click.middle="putWaitResponse()" :class="{'pointer-events-none' : waitResponse}">Votação Fotos</a>
                <a v-if="isSaler" class="text-primary active:text-shade hover:underline font-bold" href="/extrato-de-pontos" @click="putWaitResponse()" @click.middle="putWaitResponse()" :class="{'pointer-events-none' : waitResponse}">Extrato de Pontos</a>

            </ul>
      <div class="flex gap-x-10">
        <div class="relative">
          <Icon
            @click="openNotifications()"
            class="hover:text-shade text-primary cursor-pointer"
            name="Notificacao"
          />
          <div
            v-if="
              $page.props.auth.user.notifications.filter((el) => el.read == false)
                .length > 0
            "
            class="bg-red-600 absolute rounded-full top-0 right-0 translate-x-3.5 -translate-y-1/2 w-6 h-6 border-white border flex justify-center items-center text-xs text-white"
          >
            {{
              $page.props.auth.user.notifications
                ? $page.props.auth.user.notifications.filter((el) => el.read == false)
                    .length
                : ''
            }}
          </div>
        </div>

        <div class="relative">
          <Icon
            v-if="!$page.props.auth.user.photo"
            class="hover:text-shade text-primary cursor-pointer"
            name="Perfil"
            @click="
              showMenuPerfil = !showMenuPerfil;
              openedNotification = false;
            "
          />
          <img
            v-if="$page.props.auth.user.photo"
            name="Perfil"
            @click="
              showMenuPerfil = !showMenuPerfil;
              openedNotification = false;
            "
            :src="$page.props.auth.user.photo"
            class="h-7 w-7 rounded-full"
          />
          <ul
            v-if="showMenuPerfil"
            class="absolute flex flex-col w-32 bg-white whitespace-nowrap border rounded translate-y-4 -translate-x-12"
          >
            <a
              class="border-b py-1 text-center hover:bg-gray-500 hover:text-white cursor-pointer"
              @click="verifyShowKeyPhrase"
              :class="{ 'pointer-events-none': waitResponse }"
              >Meus Dados</a
            >
            <a
              class="border-b py-1 text-center hover:bg-gray-500 hover:text-white"
              href="/contact"
              @click="putWaitResponse()"
              @click.middle="putWaitResponse()"
              :class="{ 'pointer-events-none': waitResponse }"
              >Fale Conosco</a
            >
            <a
              class="py-1 text-center hover:bg-gray-500 hover:text-white cursor-pointer"
              href="/logout"
              @click="putWaitResponse()"
              @click.middle="putWaitResponse()"
              :class="{ 'pointer-events-none': waitResponse }"
              >Sair</a
            >
          </ul>
        </div>
        <svg
          @click="openMenu()"
          name="MenuLogado"
          class="text-primary hover:text-shade cursor-pointer"
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="24"
          viewBox="0 0 26 24"
        >
          <g>
            <rect width="26" height="4" rx="2" fill="#0771c5" class=" fill-current" />
            <rect
              width="26"
              height="4"
              rx="2"
              transform="translate(0 10)"
              class=" fill-current"
            />
            <rect
              width="26"
              height="4"
              rx="2"
              transform="translate(0 20)"
              fill="#0771c5"
              class=" fill-current"
            />
          </g>
        </svg>
      </div>
    </div>
  </header>
  <div v-show="openedNotification" class="flex justify-end">
    <Notifications
      @close="openNotifications"
      :data="response.data?.notifications"
      @foiLido="getNotifications()"
      class="mt-20"
    />
  </div>
  <div v-show="openenedMenu">
    <AuthMenu
    @close="openMenu"
    :can-upload-photo-in-region="canUploadPhotoInRegion"
    />
  </div>
  <MFAModal v-if="isAuthorizeModalOpen"
      :credentialauthenticationmethods="credential.credentialauthenticationmethods"
      accessTo="my-profile"
      :showModal="isAuthorizeModalOpen"
      @onCancel="cancelAuthorizationModalEvent"
      @onSuccess="successAuthorizationModalEvent" />

  <MFAModal v-if="isAuthorizeReconheceModalOpen"
      :credentialauthenticationmethods="credential.credentialauthenticationmethods"
      accessTo="reconhece"
      :showModal="isAuthorizeReconheceModalOpen"
      @onCancel="cancelAuthorizationModalEvent"
      @onSuccess="successAuthorizationReconheceModalEvent" />
</template>

<script>
import Icon from '@/Components/UI/Icons/Icon.vue';
import AuthMenu from '@/Components/UI/Nav/AuthMenu.vue';
import Notifications from '@/Components/UI/Nav/Notifications.vue';
import NavLink from '@/Components/NavLink.vue';
import axios from 'axios';
import MFAModal from "@/Components/MFA/Modal.vue";

export default {
  components: {
    Icon,
    AuthMenu,
    Notifications,
    NavLink,
    MFAModal,
  },
  data() {
    return {
      isAuthorizeModalOpen: false,
      isAuthorizeReconheceModalOpen: false,
      opened: false,
      openedNotification: false,
      openenedMenu: false,
      response: '',
      showMenuPerfil: false,
      waitResponse: false,
    };
  },
  emits: ['hiddenContent', 'showContent'],
  methods: {
    closeAuthorizationModal() {
      this.isAuthorizeModalOpen = false;
      this.isAuthorizeReconheceModalOpen = false;
    },
    openAuthorizationModal() {
      this.isAuthorizeModalOpen = true;
    },
    openAuthorizationReconheceModal() {
      this.isAuthorizeReconheceModalOpen = true;
    },
    cancelAuthorizationModalEvent() {
      this.closeAuthorizationModal();
    },
    successAuthorizationModalEvent() {
      this.closeAuthorizationModal();

      this.$inertia.get(this.route('my-profile'));
    },
    successAuthorizationReconheceModalEvent() {
      this.closeAuthorizationModal();

      setTimeout(() => {
        return window.open(this.urlReconhece, '_blank');
      })
    },
    openNotifications() {
      this.showMenuPerfil = false;
      this.openedNotification = !this.openedNotification;
      this.openedNotification ? this.getNotifications() : this.$emit('showContent');
    },

    openMenu() {
      this.openedNotification = false;
      this.openenedMenu = !this.openenedMenu;
      this.openenedMenu ? this.$emit('hiddenContent') : this.$emit('showContent');
    },

    getNotifications() {
      axios
        .get(route('notifications'))
        .then((res) => {
          this.response = res;
        })
        .then(() => {
          this.$page.props.auth.user.notifications = this.response.data.notifications;
        });
    },

    goTo(url) {
      window.location.href = url;
    },

    putWaitResponse() {
      this.waitResponse = true;

      setTimeout(() => {
        this.waitResponse = false;
      }, 1000);
    },
  },
  computed: {
    jobTitle() {
      return this.$page.props.auth.user.participant.jobTitle;
    },
    participantType() {
      return this.$page.props.auth.user.participant.type;
    },
    isMerchan() {
      return this.participantType === 'M';
    },
    isSaler() {
      return this.participantType === 'V';
    },
    isManager() {
      return this.jobTitle === 'GERENTE';
    },
    isModerator() {
      return (
        this.$page.props.auth.user.contestJudges?.length > 0 ||
        Boolean(this.$page.props.auth.user.isModerator?.data?.[0])
      );
    },
    isComputer() {
        if (navigator.userAgentData != undefined && !navigator.userAgentData.mobile) {
            return true;
        }
    },
    verifyShowKeyPhrase() {
      this.openAuthorizationModal()
    },
    credential() {
      return this.$page.props.auth.user.credential;
    },
    isDigi() {
        return this.$page.props.auth.user?.email?.includes('@digi.ag');
    },
    isAdmin() {
        return this.$page.props.auth.user?.participant?.role?.toLowerCase() == 'admin';
    },
    canUploadPhoto() {
        return this.isAdmin || this.isDigi || (this.isMerchan && !this.isManager);
    },
    canUploadPhotoInRegion() {
        return false;
    },
  },
  mounted() {
    this.getNotifications();
  },
};
</script>
